'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

module.exports = require('core-js/library/es6/map');


//////////////////
// WEBPACK FOOTER
// ./~/fbjs/lib/Map.js
// module id = 66
// module chunks = 0